import { Box, FormControlLabel, Typography } from '@mui/material'
import { PropsStep1 } from './types'
import { DinamicForm } from '../../../../../../../../../../components/dinamicForm'
import { useStyles } from './styles'
import { FiltersFloat } from '../../../../../access/components/filtersFloat'
import Loader from '../../../../../../../../../../components/loader'
import { IOSSwitch } from '../../../../../../../../../../components/dynamicFormRef/switch'
import { CustomTable } from '../../../../../../../../../../components'
import { getLocalStorage } from '../../../../../../../../../../utils/crud/crypt'
import { Roles } from '../../../../../../../../../../utils/enums'


export const Step1 = (props: PropsStep1) => {

  const styles = useStyles()

  const handleSelects = (value: number[]) => {
    props.setUsersSelected(value)
  }


  const local: { role: Roles, id: number } = getLocalStorage()

  /* useLayoutEffect(() => {
    setDonstRefresh(false)
  }, [props.table]) */

  return (
    <Box>
      <Box sx={styles.body}>
        <Box sx={{ display: 'flex', marginBottom: local.role == Roles.ADMIN ? '16px' : '0px' }}>
          <Typography sx={styles.title}>{props.t('loogbook.titles.SelectUsersToAssignActivities')}</Typography>
          <FormControlLabel
            sx={styles.switch}
            control={
              <IOSSwitch
                name="notified"
                checked={props.openField}
                onChange={({ target }) => {
                  if (props.config) {
                    props.config(target.checked)
                  }
                  if (target.checked) {
                    props.setIdOwnUser(local.id)
                  } else {
                    props.setIdOwnUser(null)
                  }
                }}
                sx={{ m: 1 }}
              />
            }
            label={props.t('loogbook.inputs.assignMeActivities')}
          />
        </Box>
      </Box>

      <CustomTable
        name={'Table'}
        tableChecks
        dontRefresh
        loader={props.loading.users}
        column={props.table.column}
        row={props.table.row}
        defaultChecks={props.usersSelected}
        onClick={(e) => { handleSelects(e.checks ?? []) }}
        selected={-1}
      /* defaulPagination={20} */
      /* serverSidePagination={{ page: props.filter.paginationModel.page + 1, size: props.filter.paginationModel.pageSize, totalPages: props.totalPages }}
      handleChange={(page: number, pageSize: number) => {
        props.filter.handlePagination({ page, pageSize })
      }} */
      />
      <FiltersFloat title={props.t('general.tags.filterByUser')} cleanFilter={props.filter.cleanFilter} count={props.filter.counter} right={-75} top={-70} searchButton={{ disabled: false, loading: props.loading.users, onClick: props.getUsersList }}>
        <DinamicForm input={Object.values(props.inputFilter)} values={props.filter.filterData} onChange={props.filter.onChange} errors={props.filter.errors} filter={true} />
      </FiltersFloat>
    </Box>
  )
}
